import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';
import type { MultiSelectFilterModifier } from '@iconik-io/shared-lib/src/redux/common_filters/types';
import { guardMultiSelectFilter } from '@iconik-io/shared-lib/src/utils/search/guard_multi_select_filter';

import {
  COLLECTIONS_ONLY_MODIFIERS,
  shouldClampCollectionsModifiers,
} from '../../constants/search_mappings';

/**
 * The modifiers the `storage_id` filter offers, clamped to `*_any_of` in the
 * collections-only case (see {@link shouldClampCollectionsModifiers}), otherwise
 * the full set. Shared by the filter panel and the active-filter chips.
 */
export function getStorageAvailableModifiers(
  storageValue: unknown,
  objectTypeValues: readonly string[] | null | undefined,
): MultiSelectFilterModifier[] | undefined {
  const groups = guardMultiSelectFilter(storageValue);
  const onlyCollectionsSelected =
    objectTypeValues?.length === 1 &&
    objectTypeValues[0] === OBJECT_TYPE_COLLECTIONS;
  const maxStoragesInAnyGroup =
    groups?.reduce((max, group) => Math.max(max, group.items.length), 0) ?? 0;
  return shouldClampCollectionsModifiers(
    onlyCollectionsSelected,
    maxStoragesInAnyGroup,
  )
    ? COLLECTIONS_ONLY_MODIFIERS
    : undefined;
}
